import { type ChangeEvent } from 'react'
import { type UseFormRegisterReturn } from 'react-hook-form'

import { type InputFormatter } from '@/components/formatters'

interface TextFieldProps {
  label: string
  registration: UseFormRegisterReturn
  error?: string
  required?: boolean
  type?: string
  placeholder?: string
  fullWidth?: boolean
  format?: InputFormatter
  inputMode?: 'text' | 'numeric' | 'decimal' | 'tel'
}

function TextField({
  label,
  registration,
  error,
  required = false,
  type = 'text',
  placeholder,
  fullWidth = false,
  format,
  inputMode,
}: TextFieldProps) {
  const { onChange, ...rest } = registration

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (format) {
      e.target.value = format(e.target.value)
    }
    return onChange(e)
  }

  return (
    <div className={`mb-2 ${fullWidth ? 'md:col-span-2' : ''}`}>
      <label htmlFor={rest.name} className="block text-xs text-gray-600">
        {label}
        {required ? <span className="text-red-500"> *</span> : null}
      </label>
      <input
        id={rest.name}
        type={type}
        inputMode={inputMode}
        placeholder={placeholder}
        className={`w-full border-0 border-b bg-transparent px-0 py-2 text-sm text-gray-900 placeholder-gray-500 focus:border-b-2 focus:outline-none ${
          error ? 'border-red-500 focus:border-red-500' : 'border-gray-400 focus:border-blue-600'
        }`}
        onChange={handleChange}
        {...rest}
      />
      {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
    </div>
  )
}

export default TextField
